import { Box } from '@mui/material';
import ICasRenderCellProps from '../ICasRenderCellProps';
import getCasTableCellValue from '../getCasTableCellValue';

export function CasRenderPercent(props: ICasRenderCellProps) {
  const value = getCasTableCellValue(props);
  return value && <Box textAlign="right">{value}%</Box>;
}
